import React from "react"
import styled from "styled-components"
import { ButtonProps, ButtonType, ButtonLink } from "../../ts/interfaces"
import CartButton from "../cart/CartButton"
import Link from "./link"
import Icon from "./Icon"
import { devices } from "../config/breakpoints"
import { queueOrSendGoogleEvent } from "../../utils/pixel"
import { cleanSlug } from "../../utils/format"
import { CircularProgress } from "@mui/material"
import { Box, height } from "@mui/system"
import { SensaiComponentIndividualButtonDef } from "../../gql/generated/graphql"

interface BtnStyleProps {
  btntype: ButtonType
  disabled: boolean
  size?: "hero" | "regular" | "control"
}
interface BtnStyleDef {
  base: string
  hover: string
  active: string
}
const btnDefs: Record<ButtonType, BtnStyleDef> = {
  text: {
    base: `
      .innerBtn{
        transition: all 0.75s ease;
        color: var(--color-grey-3) !important;
        a {
          transition: all 0.75s ease;
          color: var(--color-grey-3) !important;
        }
      }
    `,
    hover: `
    .innerBtn{
      color: var(--color-grey-4) !important;
      a {
        color: var(--color-grey-4) !important;
      }
    }
    `,
    active: `
    .innerBtn{
      color: var(--color-grey-3) !important;
      a {
        color: var(--color-grey-3) !important;
      }
    }
    `,
  },
  textSecondary: {
    base: `
      .innerBtn{
        transition: all 0.75s ease;
        color: var(--color-secondary) !important;
        a {
          transition: all 0.75s ease;
          color: var(--color-secondary) !important;
        }
      }
    `,
    hover: `
    .innerBtn{
      color: var(--color-secondary-light) !important;
      a {
        color: var(--color-secondary-light) !important;
      }
    }
    `,
    active: `
    .innerBtn{
      color: var(--color-secondary-dark) !important;
      a {
        color: var(--color-secondary-dark) !important;
      }
    }
    `,
  },
  cardArrow: {
    base: `
      .outterBtn{
        background: #ffffff;
        .innerBtn{
          color: var(--color-primary) !important;
        }
      }
      &.btn {
      display:block;
        color: var(--color-primary) !important;
      }
    `,
    hover: `
      .outterBtn{
        a {
          color: var(--color-secondary) !important;
        }
        .innerBtn{
          color: var(--color-secondary) !important;
        }
      }
        
    `,
    active: `
      .outterBtn{
        background: #ffffff;
      }
      
    `,
  },
  cardArrowFull: {
    base: `
      .outterBtn{
        background: #1d99b800;
        border-radius: 1rem;
        position: absolute;
        bottom: 0;
        right: 0;
        top: 0;
        left:0;
        
        .innerBtn{
          position: absolute;
          bottom: 1rem;
          right: 1rem;
          background: #ffffff;
          color: var(--color-primary) !important;
        }
      }
      &.btn {
      display:block;
        width: 100% !important;
        color: var(--color-primary) !important;
      }
    `,
    hover: `
      .outterBtn{
        background: #1d99b811; 
        
        box-shadow:  0px 0px 15px var(--color-teal);
        .innerBtn{
          color: var(--color-secondary) !important;
        }
      }
      &.btn {
        color: var(--color-secondary) !important;
      }
        
    `,
    active: `
      .outterBtn{
        
      }
      
    `,
  },
  primary: {
    base: `
      .outterBtn{
        background: linear-gradient(270deg, var(--color-secondary) 2%, var(--color-primary) 98%);
        .innerBtn{
          color: var(--color-white) !important;
        }
      }
      a {
        color: var(--color-white) !important;
      }
    `,
    hover: `
      .outterBtn{
        background: linear-gradient(270deg, var(--color-secondary) 2%, var(--color-secondary) 98%);
        a {
          color: var(--color-white) !important;
        }
        .innerBtn, .innerBtn span:hover{
          color: var(--color-white) !important;
        }
      }
    `,
    active: `
      .outterBtn{
        background: linear-gradient(270deg, var(--color-secondary-light) 2%, var(--color-secondary-light) 98%);
      }
      
    `,
  },
  primaryOutline: {
    base: `
      position: relative;
      .outterBtn{
        background: linear-gradient(270deg, var(--color-secondary) 2%, var(--color-primary) 98%);
        .innerBtn{
          background: var(--color-white) !important;
          color: var(--color-primary) !important;
        }
      }
      
      a {
        color: var(--color-primary) !important;
      }
    
    `,
    hover: `
      a {
        color: var(--color-secondary) !important;
      }
      .outterBtn{
        background: linear-gradient(270deg, var(--color-secondary-light) 2%, var(--color-secondary-light) 98%);
        .innerBtn{
          color: var(--color-secondary) !important;
        }
      }
    `,
    active: `
      color: var(--color-primary) !important;
      a {
        color: var(--color-primary) !important;
      }
      .outterBtn{
        .innerBtn{
          color: var(--color-primary) !important;
        }
      }
    `,
  },
  primaryTab: {
    base: `
      .outterBtn{
        padding: 1px 1px 3px 1px;
        border-radius: 2rem 2rem 0 0;
        background: var(--color-white) ;
        .innerBtn{
          border-radius: 2rem 2rem 0 0;
          background: var(--color-white) !important;
          color: var(--color-primary) !important;
        }
      }
      
      a {
        color: var(--color-primary) !important;
      }
      
      
    `,
    hover: `
      
      a {
        color: var(--color-secondary) !important;
      }
      .outterBtn{
        background: linear-gradient(270deg, var(--color-secondary) 2%, var(--color-primary) 98%);
        .innerBtn{
          color: var(--color-secondary) !important;
        }
      }
    `,
    active: `
      
      a {
        color: var(--color-primary) !important;
      }
      .outterBtn{
        .innerBtn{
          color: var(--color-primary) !important;
        }
      }
    `,
  },
  primaryTabActive: {
    base: `
    .outterBtn{
        padding: 1px 1px 3px 1px;
        border-radius: 2rem 2rem 0 0;
        background: var(--color-secondary-light) !important;
        .innerBtn{
          border-radius: 2rem 2rem 0 0;
          background: var(--color-white) !important;
        }
      }
      color: var(--color-secondary) !important;
      a {
        color: var(--color-secondary) !important;
      }
      
    `,
    hover: `
      color: var(--color-primary) !important;
      a {
        color: var(--color-primary) !important;
      }
      .outterBtn{
        background: var(--color-secondary-light) !important;
      }
    `,
    active: `
      color: var(--color-secondary-dark) !important;
      a {
        color: var(--color-secondary-dark) !important;
      }
    `,
  },
  secondary: {
    base: `
      text-transform: uppercase;
      .outterBtn{
        background: var(--color-secondary) !important;
        .innerBtn{
        span{
          color: var(--color-white) !important;
  }
        }
      }
      

    `,
    hover: `
    .outterBtn{
      background: var(--color-secondary-light) !important;
      .innerBtn{
          color: var(--color-white) !important;
        }
    }
        a {
        color: var(--color-white) !important;
      }
    `,
    active: `
    .outterBtn{
        background: var(--color-secondary-dark) !important;
    }
    `,
  },
  secondaryOutline: {
    base: `
      position: relative;
      .outterBtn{
        background: var(--color-secondary) !important;
        .innerBtn{
          background: var(--color-white) !important;
          color: var(--color-secondary) !important;
        }
      }
      
      a {
        color: var(--color-secondary) !important;
      }
    
      
    `,
    hover: `
      
      a {
        color: var(--color-primary) !important;
      }
      .outterBtn{
        background: var(--color-primary-light) !important;
        .innerBtn{
          color: var(--color-primary) !important;
        }
      }
    `,
    active: `
      
      a {
        color: var(--color-primary) ;
      }
      .outterBtn{
        .innerBtn{
          color: var(--color-primary) !important;
        }
      }
    `,
  },
  link: {
    base: `
        height: auto !important;
        font-weight: 500;
        & a, & span{
         font-size: 1rem !important;
         line-height:1.5rem !important;
        }
        letter-spacing: 0;
        
        text-transform: none;
      
    `,
    active: `
      color: var(--color-secondary-dark);
    `,
    hover: `
      color: var(--color-link-hover);
      cursor: pointer;
      transition: color .5s;
      text-decoration: underline;
    `,
  },
  linkWhite: {
    base: `
        height: auto !important;
        font-weight: 500;
        & a, & span{
         font-size: 1rem !important;
         line-height:1.5rem !important;
        }
        letter-spacing: 0;
        color: var(--color-white);  
        text-transform: none;
      
    `,
    active: `
      color: var(--color-white);
    `,
    hover: `
      color: var(--color-teal-light);
      & a, & span{
        color: var(--color-teal-light);
      }
      cursor: pointer;
      transition: color .5s;
      text-decoration: underline;
    `,
  },
  linkArrow: {
    base: `
        height: auto !important;
        font-weight: 500;
        & a, & span{
         font-size: 1rem !important;
         line-height:1.65rem !important;
        }
        letter-spacing: 0;
        text-decoration: underline;
        text-transform: none;
    `,
    active: `
      color: var(--color-secondary-dark);
    `,
    hover: `
      color: var(--color-link-hover);
      cursor: pointer;
      transition: color .5s;
      text-decoration: underline;
    `,
  },
  linkArrowEmphasis: {
    base: `
        height: auto !important;
        font-weight: 400;
        & a, & span{
         font-size: 1.25rem !important;
         line-height:1.65rem !important;
         color: var(--color-grey-6);
        }
        letter-spacing: 0;
        text-decoration: underline;
        text-transform: none;
        text-underline-offset: 0.5rem;
        color: var(--color-grey-6);
       .svg-inline--fa {
          font-size: 1.1rem;
          color: var(--color-secondary-dark);
        }
    `,
    active: `
      color: var(--color-secondary-dark);
    `,
    hover: `
      color: var(--color-link-hover);
      cursor: pointer;
      & a, & span{
        color: var(--color-link-hover);
      }
      transition: color .5s;
      text-decoration: underline !important;
    `,
  },
  white: {
    base: `
      .outterBtn{
        background: var(--color-white) !important;
      }
      color: var(--color-grey-4) !important;
      a {
        color: var(--color-grey-4) !important;
      }
    `,
    hover: `
    .outterBtn{
      background: var(--color-grey-1) !important;
    }
    `,
    active: `
      .outterBtn{
        background: var(--color-secondary-light) !important;
      }
    `,
  },
  whiteOutline: {
    base: `
      position: relative;
      .outterBtn{
        background: transparent;
        .innerBtn{
          border: 3px solid var(--color-white) !important;
          background: transparent;
        }
      }
      color: var(--color-white) !important;
      a {
        color: var(--color-white) !important;
      }
      
    `,
    hover: `
    .outterBtn{
      background: var(--color-primary-light);
    }
    `,
    active: `
    .outterBtn{
      background: var(--color-primary-dark);
    }
    `,
  },
}

type AlignmentType = "center" | "right" | "left"

const getJustifyContentFromAlign = (align: AlignmentType) => {
  switch (align) {
    case "right":
      return "flex-end"
    case "left":
      return "flex-start"
    case "center":
      return "center"
    default:
      return "center"
  }
}

export const Buttons = styled.div<{
  margin?: number
  align?: "center" | "right" | "left"
}>`
  margin-top: ${({ margin }) =>
    margin !== null && margin !== undefined ? `${margin}px` : "40px"};
  display: flex;
  vertical-align: center;
  text-align: center;
  align-items: center;
  justify-content: ${({ align }) =>
    align ? getJustifyContentFromAlign(align) : "center"};
  flex-wrap: wrap;
  > .btn {
    margin-right: 2rem;
    margin-bottom: 2rem;
  }
`

const heroHeight = 4
const regularHeight = 2.7
const controlHeight = 1.75

const heroPadding = 1.75
const regularPadding = 1.0
const controlPadding = 0.5

const getBtnStyle = (btnProps: BtnStyleProps) => `
  font-family: var(--font-family-header);
  font-weight:600;
  letter-spacing: ${btnProps.size !== "control" ? "0.06875rem" : "0.056rem"};
  opacity: ${btnProps.disabled ? "0.4" : "1"};
  
  border: 0px solid transparent;
  border-radius: 5rem;

  

  display: flex;
  position: relative;
  text-transform: uppercase;
  
  
  a, span, a span, span span{
    text-decoration:none;
    
    font-size: ${
      btnProps.size !== "control" ? "1.1875rem" : "0.80rem"
    } !important;

    @media ${devices.mobile} {
      font-size: ${btnProps.size !== "control" ? "1rem" : "0.70rem"} !important;
    }
  }
  
  
  transition: all 0.75s ease;
  .outterBtn{
    padding:3px;
    
    transition: all 0.75s ease;
    display: flex;
    vertical-align: center;
    text-align: center;
    align-items: center;

    cursor: pointer;
    line-height: 1.5rem;  
    border-radius: 5rem;
    .innerBtn{
      margin:0;
      transition: all 0.75s ease;
      padding:0 ${
        btnProps.size === "hero"
          ? `${heroPadding}rem`
          : btnProps.size === "control"
          ? `${controlPadding}rem`
          : `${regularPadding}rem`
      };
      line-height: ${
        btnProps.size === "hero"
          ? `${heroHeight}rem`
          : btnProps.size === "control"
          ? `${controlHeight}rem`
          : `${regularHeight}rem`
      };
      @media ${devices.mobile} {
        padding:0 ${
          btnProps.size === "hero"
            ? `${heroPadding * 0.75}rem`
            : btnProps.size === "control"
            ? `${controlPadding * 0.75}rem`
            : `${regularPadding * 0.75}rem`
        };
        line-height: ${
          btnProps.size === "hero"
            ? `${heroHeight * 0.8}rem`
            : btnProps.size === "control"
            ? `${controlHeight * 0.8}rem`
            : `${regularHeight * 0.8}rem`
        };
      }
     
      white-space: nowrap;
      border-radius: 5rem;
      
      vertical-align:middle;
      } !important;
    }
  }

  ${btnDefs[btnProps.btntype].base}


  :hover {
    text-decoration:none;
    color: var(--color-white);
    ${btnProps.disabled ? "" : btnDefs[btnProps.btntype].hover}
  }
  
  :focus, :active{
    text-decoration:none;
    ${btnDefs[btnProps.btntype].active}
    outline: none;
  }
`

export const LinkBtnBase = styled(props => <Link {...props} />)`
  ${props => getBtnStyle(props)}
`

const BtnSubmit = styled(props => <button {...props} />)`
  background-color: transparent;
  ${props => getBtnStyle(props)}
`
export const ButtonBase = (button: ButtonProps) => {
  const size = button.size || "normal"
  let id = button.id ? `${button.id}` : `${button.title}`
  id += button.sectionId ? `_${button.sectionId}` : "_x"
  button.title && button.id
  id = id.split(" ").join("_").toLowerCase()

  if (
    ["cardArrow", "cardArrowFull", "linkArrow", "linkArrowEmphasis"].includes(
      button.type
    )
  ) {
    button.icon = "arrow-right"
  }
  const iconStart =
    button.icon && !["linkArrow", "linkArrowEmphasis"].includes(button.type)
  const iconEnd = button.icon && !iconStart

  const icon =
    button.icon && button.icon === "loadingSpinner" ? (
      <CircularProgress size={15} color="inherit" />
    ) : button.icon && typeof button.icon === "string" ? (
      <Icon
        iconType="Solid"
        iconName={button.icon}
        size={
          size === "hero" || button.type.startsWith("cardArrow") ? "2x" : "sm"
        }
      />
    ) : button.icon && React.isValidElement(button.icon) ? (
      button.icon
    ) : button.icon ? (
      <Box
        sx={{ verticalAlign: "-0.2em", height: "1em", display: "inline-block" }}
      >
        <button.icon />
      </Box>
    ) : null

  const baseSpan = button.type.includes("link") ? (
    <span className="text">
      {button.icon && iconStart && (
        <>
          {icon}
          <span style={{ marginRight: "10px" }}> </span>
        </>
      )}
      {button.title}
      {button.icon && iconEnd && (
        <>
          <span style={{ marginRight: "10px" }}> </span>
          {icon}
        </>
      )}
    </span>
  ) : (
    <span className="outterBtn">
      <span className="innerBtn">
        {button.icon && iconStart && icon}
        {button.icon &&
          button.title &&
          iconStart &&
          !button.type.startsWith("cardArrow") && (
            <span style={{ marginRight: "10px" }}> </span>
          )}
        {!button.type.startsWith("cardArrow") && (
          <span className="text">{button.title}</span>
        )}
        {button.icon &&
          button.title &&
          iconEnd &&
          !button.type.startsWith("cardArrow") && (
            <span style={{ marginRight: "10px" }}> </span>
          )}
        {button.icon && iconEnd && icon}
      </span>
    </span>
  )
  return baseSpan
}

export const getUrlFromButtonLink = (link?: ButtonLink) => {
  if (!link) {
    return ""
  }

  if (link.product?.slug) {
    return link.addToCart
      ? "/store/checkout"
      : `${cleanSlug(link.product.slug)}`
  }
  let url = link.url
    ? link.url
    : link.navItemPage
    ? link.navItemPage.slug
    : link.navItemLandingPage
    ? link.navItemLandingPage.slug
    : ""

  url = cleanSlug(!link?.anchor ? url : `${url}#${link.anchor}`)
  return url
}

export const getUrlFromButtonDef = (
  link?: SensaiComponentIndividualButtonDef
) => {
  if (!link) {
    return ""
  }
  if (link.product?.slug) {
    return link.addToCart
      ? "/store/checkout"
      : `${cleanSlug(link.product.slug)}`
  }
  let url = link.urlLink
    ? link.urlLink
    : link.page?.slug
    ? link.page.slug
    : link.landingPage?.slug
    ? link.landingPage.slug
    : ""

  url = cleanSlug(!link.anchor ? url : `${url}#${link.anchor}`)
  return url
}

export const Button = (button: ButtonProps) => {
  const link: ButtonLink | undefined = button.link && button.link[0]

  const size = button.size || "normal"
  let id = button.id ? `${button.id}` : `${button.title}`
  id += button.sectionId ? `_${button.sectionId}` : "_x"
  // button.title && button.id

  id = id.split(" ").join("_").toLowerCase()
  id = id.split(":").join("_").toLowerCase()

  const baseSpan = ButtonBase(
    link && link.navItemName
      ? { ...button, title: link.navItemName }
      : link && link.linkText
      ? { ...button, title: link.linkText }
      : button
  )

  if (link && link.product) {
    return (
      <LinkBtnBase
        id={id}
        title={button.title}
        aria-label={button.title}
        btntype={button.type}
        size={size}
        disabled={button.disabled || false}
        className={`btn ${button.className}`}
        to={getUrlFromButtonLink(link)}
        data-testid={button.testId}
      >
        <CartButton aria-label={button.title} {...button}>
          {baseSpan}
        </CartButton>
      </LinkBtnBase>
    )
  } else if (button.submit) {
    return (
      <BtnSubmit
        id={id}
        type="submit"
        aria-label={button.title}
        btntype={button.type}
        size={size}
        disabled={button.disabled || false}
        className={`btn ${button.className}`}
        data-testid={button.testId}
        onClick={d => {
          if (button.disabled === true) {
            return
          }
          if (button.gTagEvent) {
            queueOrSendGoogleEvent(button.gTagEvent)
          }
          if (button.onClick) {
            button.onClick(d)
          }
        }}
      >
        {baseSpan}
      </BtnSubmit>
    )
  }

  let url = button.disabled === true ? "" : getUrlFromButtonLink(link)

  return (
    <LinkBtnBase
      id={id}
      title={button.title}
      aria-label={button.title}
      to={url || ""}
      onClick={d => {
        if (button.disabled === true) {
          return
        }
        if (button.gTagEvent) {
          queueOrSendGoogleEvent(button.gTagEvent)
        }
        if (button.onClick) {
          button.onClick(d)
        }
      }}
      btntype={button.type}
      size={size}
      disabled={button.disabled || false}
      className={`btn ${button.className}`}
      data-testid={button.testId}
    >
      {baseSpan}
    </LinkBtnBase>
  )
}
